import type { CityViewModel } from 'api/types/city';

const PRIORITY_CITY_NAMES = ['İstanbul', 'Istanbul', 'İzmir', 'Izmir'];

function cityPriorityIndex(name: string | null | undefined): number {
  if (!name) return PRIORITY_CITY_NAMES.length + 1;
  const normalized = name.trim().toLocaleLowerCase('tr-TR');
  const idx = PRIORITY_CITY_NAMES.findIndex(
    (priority) => priority.toLocaleLowerCase('tr-TR') === normalized
  );
  return idx >= 0 ? idx : PRIORITY_CITY_NAMES.length;
}

/** İstanbul and İzmir first, then remaining cities alphabetically (Turkish locale). */
export function sortCities(cities: CityViewModel[]): CityViewModel[] {
  return [...cities].sort((a, b) => {
    const priorityDiff = cityPriorityIndex(a.name) - cityPriorityIndex(b.name);
    if (priorityDiff !== 0) return priorityDiff;
    return (a.name ?? '').localeCompare(b.name ?? '', 'tr-TR');
  });
}
